// extracted by mini-css-extract-plugin
export default {"filter":"VMdmWaU5TCAH5TjO_MVP","title":"WOtWAE0kPs2YMt1fQpLh"};